<template>
  <div id="app" :class="{blurred: modelWindowOpen}">
    <NavigationMenu class="blurable" fileName="saab-logo-white.svg"/>
    <transition-page>
      <router-view class="page"/>
    </transition-page>
  </div>
</template>

<script>
import TransitionPage from "@/transitions/TransitionPage";
import NavigationMenu from '@/components/NavigationMenu';
import gd from "@/assets/stores/globalDS.js";

export default {
  components: {
    NavigationMenu,
    TransitionPage
  },
  data() {
    return {
      modelWindowOpen: false
    }
  },
  created: function() {
    const that = this;

    this.$root.$on('openModelWindow', _ => that.modelWindowOpen = true)
    this.$root.$on('closeModelWindow', _ => that.modelWindowOpen = false)
  }
}
</script>

<style lang="scss">

@import "assets/scss/import";


@media screen and (orientation: portrait) {
    :root { font-size: 10px; }
    @media (max-width: 768px) {
        :root { font-size: 100vw * (10/768); }
    }
    @media (min-width: 1080px) {
        :root { font-size: 100vw * (10/1080); }
    }
}
@media screen and (orientation: landscape) {
    :root { font-size: 10px; }
    @media (max-height: 768px) {
        :root { font-size: 100vh * (10/768); }
    }
    @media (min-height: 1080px) {
        :root { font-size: 100vh * (10/1080); }
    }
}

* {
  -webkit-tap-highlight-color: rgba(0,0,0,0) !important;

  &::-webkit-scrollbar {
        width: 0;
        background: transparent;
    }
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;
}

html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  -ms-overflow-style: none;
}

#app {
  font-family: 'Aktiv Grotesk Normal', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: relative;
  height: 100%;
  transition: height 0.5s;
  background-color: $colour__primary1;
  &.home {
    height: 100%;
  }
}

.page {
  height: calc(100% - 5.4rem);
  position: absolute;
  top: 5.4rem;
  left: 0;
  width: 100%;
  transform: translate(0,0,0);
  background-color: $colour__primary1;
}

.footer {
  border-top: 1px solid $colour__primary1;
  padding: 2em;
  margin-top: 2em;
}

.blurable {
  transition: filter 0.5s;
  #app.blurred & {
    filter: blur(5px);
  }
}

.delayReveal {
  opacity: 0;
  animation-name: revealAnimation;
  animation-duration: 0.5s;
  animation-delay: 1s;
  animation-fill-mode: forwards;
  &--long {
    animation-delay: 2s;
  }
}

.reveal {
  opacity: 0;
  .animationComplete & {
    transition: all 0.5s;
    opacity: 1;
  }
}

@keyframes revealAnimation {
  from { 
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.scenarioNextButton {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 500;
}

.scenarioPreviousButton {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 500;
  svg {
    transform: rotate(180deg);
  }
}

.galleryButton {
  position: absolute;
  bottom: 0;
  left: 5rem;
  z-index: 500;
}

.replayButton {
  position: relative;
  z-index: 500;
  margin-top: 1rem;
}

.button {
  font-family: $fontFamily--bold;
  font-size: 1.2rem;
}

.modelWindow ul {
  margin: initial;
  font-size: 1.2rem;
  list-style: initial;
  padding-left: 2em;
  li {
    padding-left: initial;
    margin-left: initial;
    list-style: initial;
  }
}

</style>
